<template>
  <el-form :model="ruleForm" ref="ruleForm" label-position="right" label-width="120px">
    <el-form-item :label="$t('papel')">
      <RoleList v-model="ruleForm.role" @selected="list" />
    </el-form-item>
    <MessageAddTableUsers ref="tableUsers" />
  </el-form>
</template>

<script>
import { RoleService } from "@/services/role/role.services";
import RoleList from "../../../register/role/RoleList.vue";
import MessageAddTableUsers from "./MessageAddTableUsers.vue";
export default {
  name: "MessageAddUsersRole",
  data: function () {
    return {
      tableData: [],
      ruleForm: {
        role: '',
      },
      name: ''
    };
  },
  methods: {
    list(role, name) {
      this.$refs.tableUsers.show(role, '3')
      this.name = name;
    },
    get() {
      const vm = this;
      const userSeleteds = this.$refs.tableUsers.get();
      if (userSeleteds.length > 0) {
        return userSeleteds.map(x => {
          return {
            type: 'user',
            value: x.id,
            label: x.name,
          }
        })
      } else if (this.ruleForm.role == '') {
        return this.$message({
          type: "error",
          duration: 5000,
          message: "Nenhum papel ou usuário selecionado",
        });
      } else {
        return [{ type: 'role', value: vm.ruleForm.role, label: "Todas os usuários do papel " + vm.name }]
      }
    },
    fetch() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      RoleService.list()
        .then((response) => {
          vm.tableData = response.records;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
  },
  mounted() {
    const vm = this;
    //vm.fetch();
  },
  components: { RoleList, MessageAddTableUsers }
};
</script>